// eslint-disable-next-line max-len
var USER_INTERFACE_ARROW_01 = 'M31.68,16.72a0,0,0,0,1,0,0l-9.91,8.89h0a1,1,0,0,1-1.41-.07,1,1,0,0,1,.08-1.42l8-7.14H1a1,1,0,0,1,0-2H28.39l-8-7.14a1,1,0,0,1-.08-1.42,1,1,0,0,1,1.41-.07l9.91,8.89v0a.81.81,0,0,1,.17.23l.07.09a1,1,0,0,1,0,.8l-.07.09A.81.81,0,0,1,31.68,16.72Z';

export { USER_INTERFACE_ARROW_01 };
//# sourceMappingURL=USER_INTERFACE_ARROW_01.js.map
